import {Platform} from 'react-native';

/**
 * Injects CSS animations for web platform to prevent double animations
 * with react-native-reanimated
 */
export const injectWebAnimations = () => {
  if (Platform.OS !== 'web' || typeof document === 'undefined') {
    return;
  }

  const styleId = 'screen-animations';
  if (document.getElementById(styleId)) {
    return; // Already injected
  }

  const style = document.createElement('style');
  style.id = styleId;
  style.textContent = `
    @keyframes fadeInUp {
      from {
        opacity: 0;
        transform: translateY(20px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }

    @keyframes fadeInDown {
      from {
        opacity: 0;
        transform: translateY(-20px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }

    @keyframes fadeIn {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }

    .screen-fade-in-up {
      animation: fadeInUp 0.4s ease-out forwards;
      animation-fill-mode: both;
    }

    .screen-fade-in-down {
      animation: fadeInDown 0.4s ease-out forwards;
      animation-fill-mode: both;
    }

    .screen-fade-in {
      animation: fadeIn 0.3s ease-out forwards;
      animation-fill-mode: both;
    }
  `;
  document.head.appendChild(style);
};

// Auto-inject on import for web
injectWebAnimations();

